<template>
    <template v-if="file_path==''">
    <br>
    <h4>{{sectionRouteObject[0].name}}</h4>
    <ul v-for="route in sectionRoutes" v-bind:key="route">
            <li><a :href="route.path">{{route.name}}</a></li>
    </ul>
    </template>
    <template v-else>
        <UserPage :file_path=file_path></UserPage>
    </template>
</template>

<style scoped src="@/assets/documentation.css">
</style>

<script>
import UserPage from '@/components/UserPage'
export default {
    name: 'UserSectionSummaryPage',
    props: {
        url : String,
        file_path : String
    },
    computed: {
        sectionRoutes() {
            var allRoutes = this.$router.getRoutes();
            return allRoutes.filter( route => route.path.includes(this.url) && route.path != this.url && !route.path.includes(":"));
        },
        sectionRouteObject() {
            var allRoutes = this.$router.getRoutes();
            return allRoutes.filter( route => route.path == this.url );
        }
    },
    components: {
        UserPage,
    }
}
</script>